<template>
  <div
    v-if="description"
    class="padding-16 background-surface border--solid border--complementary-50 border-radius-8 margin-bottom-16"
  >
    <div
      class="font-size-16 font-weight-500 color-complementary-400 margin-bottom-8"
    >
      {{ title }}
    </div>
    <p
      class="font-size-14 color-complementary-300 padding-8 text-justify"
      v-html="description"
    />
  </div>
</template>

<script>
import { computed, inject } from "vue";
import { pathOr } from "ramda";
export default {
  setup() {
    const currentTab = inject("CURRENT_TAB");
    const title = computed(() => pathOr("", ["text"], currentTab.value));
    const description = computed(() =>
      pathOr("", ["description"], currentTab.value)
    );

    // return data to be used in template
    return { title, description };
  },
};
</script>
